module.exports = __webpack_public_path__ + "img/tz.53855cd8.svg";